var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H9.72727C8.28064 1 6.89325 1.57946 5.87033 2.61091C4.8474 3.64236 4.27273 5.04131 4.27273 6.5V9.8H1V14.2H4.27273V23H8.63636V14.2H11.9091L13 9.8H8.63636V6.5C8.63636 6.20826 8.7513 5.92847 8.95588 5.72218C9.16047 5.51589 9.43795 5.4 9.72727 5.4H13V1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3db302a6d2a6f4adae9f72e3a4a14b08.svg";
export { ForwardRef as ReactComponent };